import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import WhyRoofsFail from "@/pages/WhyRoofsFail";
import GuardianProgram from "@/pages/GuardianProgram";
import ServicesOverview from "@/pages/ServicesOverview";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Resources from "@/pages/Resources";
import ArticleDetail from "@/pages/ArticleDetail";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SunshineCoast from "@/pages/SunshineCoast";
import ScrollToHash from "@/components/ScrollToHash";
import GoogleAnalytics from "@/components/GoogleAnalytics";

/* ──────────────────────────────────────────────────────────────────
 * Note on code splitting (React.lazy):
 *
 * This site uses react-snap to prerender every public route to static
 * HTML at build time (see package.json reactSnap config). React 18's
 * built-in React.lazy() is NOT SSR/prerender-safe — wrapping the
 * <Routes> in a Suspense boundary causes a hydration mismatch on every
 * route (React error #418) which forces a full client re-render and
 * actually HURTS LCP rather than helps. Eager imports are therefore the
 * correct architecture for this site. If route-level code splitting is
 * ever needed in the future, switch to @loadable/component which is
 * purpose-built for prerender + split.
 *
 * Note on legacy routes:
 *
 * Historical Wix-era paths (/about-1, /contact-8, /the-program,
 * /guardian-assessment, /case-studies, /insurers, /general-5, /blank*,
 * /audit) are 301-redirected at the Netlify edge via netlify.toml BEFORE
 * React is reached, so no SPA route is needed. Any stale component for
 * those routes was retired in the SEO legacy-URL cleanup pass.
 * ────────────────────────────────────────────────────────────────── */

const TOASTER_OPTIONS = {
    classNames: {
        toast:
            "rounded-2xl border border-srm-line bg-white text-srm-ink shadow-medium",
    },
};

function App() {
    return (
        <div className="App">
            <a
                href="#main"
                data-testid="skip-to-main"
                className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-sm focus:bg-srm-gold focus:text-white focus:text-[12px] focus:font-semibold focus:tracking-[0.18em] focus:uppercase focus:shadow-lg"
            >
                Skip to main content
            </a>
            <BrowserRouter>
                <ScrollToHash />
                <GoogleAnalytics />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/why-roofs-fail" element={<WhyRoofsFail />} />
                    <Route path="/guardian-program" element={<GuardianProgram />} />
                    <Route path="/services" element={<ServicesOverview />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/resources/:slug" element={<ArticleDetail />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/sunshine-coast-strata-roof-assessments" element={<SunshineCoast />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                richColors
                closeButton
                toastOptions={TOASTER_OPTIONS}
            />
        </div>
    );
}

export default App;
